export const sections =
{
    "sections": [
      {
        "sectionName": "Trending Now",
        "sectionDetail": [
          {
            "movieName": "Force",
            "imageUrl": "assets/Movies/K1.jpg"
          },
          {
            "movieName": "Bang Bang",
            "imageUrl": "assets/Movies/AD1.jpg"
          },
          {
            "movieName": "Kick",
            "imageUrl": "assets/Movies/K3.jpg"
          },
          {
            "movieName": "Runway",
            "imageUrl": "assets/Movies/AD4.jpg"
          },
          {
            "movieName": "Dost",
            "imageUrl": "assets/Movies/AD8.jpg"
          },
          {
            "movieName": "War",
            "imageUrl": "assets/Movies/War.jpg"
          },
          {
            "movieName": "Players",
            "imageUrl": "assets/Movies/Players.jpg"
          },
          {
            "movieName": "Don 2",
            "imageUrl": "assets/Movies/K14.jpg"
          },
          {
            "movieName": "Fateh",
            "imageUrl": "assets/Movies/K4.jpg"
          },
          {
            "movieName": "Kisi Ka Bhai Kisi Ki Jaan",
            "imageUrl": "assets/Movies/AD17.jpg"
          },
          {
            "movieName": "Yodha",
            "imageUrl": "assets/Movies/AD12.jpg"
          },
          {
            "movieName": "GanguBai Kathawadi",
            "imageUrl": "assets/Movies/GanguBaiKathawadi.jpg"
          },
          {
            "movieName": "Munna Michael",
            "imageUrl": "assets/Movies/K2.jpg"
          },
          {
            "movieName": "Bhediya",
            "imageUrl": "assets/Movies/k15.jpg"
          },
          {
            "movieName": "Mother India",
            "imageUrl": "assets/Movies/MotherIndia.jpg"
          },
          {
            "movieName": "Baazaar",
            "imageUrl": "assets/Movies/Baazaar.jpg"
          },
          {
            "movieName": "RRR",
            "imageUrl": "assets/Movies/RRR.jpg"
          }
        ]
      },
      {
        "sectionName": "Action",
        "sectionDetail": [
          {
            "movieName": "Force",
            "imageUrl": "assets/Movies/Force.jpg"
          },
          {
            "movieName": "Bang Bang",
            "imageUrl": "assets/Movies/BangBang.jpg"
          },
          {
            "movieName": "Kick",
            "imageUrl": "assets/Movies/Kick.jpg"
          },
          {
            "movieName": "Runway",
            "imageUrl": "assets/Movies/Runway.jpg"
          },
          {
            "movieName": "Dost",
            "imageUrl": "assets/Movies/Dost.jpg"
          },
          {
            "movieName": "War",
            "imageUrl": "assets/Movies/War.jpg"
          },
          {
            "movieName": "Players",
            "imageUrl": "assets/Movies/Players.jpg"
          },
          {
            "movieName": "Don 2",
            "imageUrl": "assets/Movies/Don2.jpg"
          },
          {
            "movieName": "Fateh",
            "imageUrl": "assets/Movies/Fateh.jpg"
          },
          {
            "movieName": "Kisi Ka Bhai Kisi Ki Jaan",
            "imageUrl": "assets/Movies/KisiKaBhaiKisiKiJaan.jpg"
          },
          {
            "movieName": "Yodha",
            "imageUrl": "assets/Movies/Yodha.jpg"
          },
          {
            "movieName": "GanguBai Kathawadi",
            "imageUrl": "assets/Movies/GanguBaiKathawadi.jpg"
          },
          {
            "movieName": "Munna Michael",
            "imageUrl": "assets/Movies/MunnaMichael.jpg"
          },
          {
            "movieName": "Bhediya",
            "imageUrl": "assets/Movies/Bhediya.jpg"
          },
          {
            "movieName": "Mother India",
            "imageUrl": "assets/Movies/MotherIndia.jpg"
          },
          {
            "movieName": "Baazaar",
            "imageUrl": "assets/Movies/Baazaar.jpg"
          },
          {
            "movieName": "RRR",
            "imageUrl": "assets/Movies/RRR.jpg"
          }
        ]
      },
      {
        "sectionName": "Hollywood",
        "sectionDetail": [
          {
            "movieName": "The Rocky Horror Picture Show",
            "imageUrl": "assets/Movies/TheRockyHorrorPictureShow.jpg"
          },
          {
            "movieName": "The Quiet Girl",
            "imageUrl": "assets/Movies/theQuietGirl.jpg"
          },
          {
            "movieName": "The Picture of Dorian Gray",
            "imageUrl": "assets/Movies/ThePictureofDorianGray.jpg"
          },
          {
            "movieName": "Jurassic Park",
            "imageUrl": "assets/Movies/JurassicPark.jpg"
          },
          {
            "movieName": "House Of Gucci",
            "imageUrl": "assets/Movies/HouseOfGucci.jpg"
          },
          {
            "movieName": "The Wolf of Wall Street",
            "imageUrl": "assets/Movies/TheWolfofWallStreet.jpg"
          },
          {
            "movieName": "Titanic",
            "imageUrl": "assets/Movies/Titanic.jpg"
          },
          {
            "movieName": "Shutter Island",
            "imageUrl": "assets/Movies/ShutterIsland.jpg"
          },
          {
            "movieName": "Guardians of The Galaxy",
            "imageUrl": "assets/Movies/GuardiansofTheGalaxy.jpg"
          },
          {
            "movieName": "Empire Strikes Back",
            "imageUrl": "assets/Movies/EmpireStrikesBack.jpg"
          },
          {
            "movieName": "Dora & The Lost City Of Gold",
            "imageUrl": "assets/Movies/DoraandTheLostCityOfGold.jpg"
          },
          {
            "movieName": "Harry Potter",
            "imageUrl": "assets/Movies/HarryPotter.jpg"
          },
          {
            "movieName": "Jaws",
            "imageUrl": "assets/Movies/Jaws.jpg"
          },
          {
            "movieName": "Avengers Infinity War",
            "imageUrl": "assets/Movies/AvengersInfinityWar.jpg"
          },
          {
            "movieName": "John Wick",
            "imageUrl": "assets/Movies/JohnWick.jpg"
          },
          {
            "movieName": "Beauty & The Beast",
            "imageUrl": "assets/Movies/BeautyAndTheBeast.jpg"
          },
          {
            "movieName": "Replicas",
            "imageUrl": "assets/Movies/Replicas.jpg"
          },
          {
            "movieName": "Joker",
            "imageUrl": "assets/Movies/Joker.jpg"
          },
          {
            "movieName": "Casino",
            "imageUrl": "assets/Movies/Casino.jpg"
          },
          {
            "movieName": "SuperBad",
            "imageUrl": "assets/Movies/SuperBad.jpg"
          }
        ]
      },
      {
        "sectionName": "K-Dramas",
        "sectionDetail": [
          {
            "movieName": "The Rocky Horror Picture Show",
            "imageUrl": "assets/Movies/K1.jpg"
          },
          {
            "movieName": "The Quiet Girl",
            "imageUrl": "assets/Movies/K2.jpg"
          },
          {
            "movieName": "The Picture of Dorian Gray",
            "imageUrl": "assets/Movies/K3.jpg"
          },
          {
            "movieName": "Jurassic Park",
            "imageUrl": "assets/Movies/K4.jpg"
          },
          {
            "movieName": "House Of Gucci",
            "imageUrl": "assets/Movies/K5.jpg"
          },
          {
            "movieName": "The Wolf of Wall Street",
            "imageUrl": "assets/Movies/K6.jpg"
          },
          {
            "movieName": "Titanic",
            "imageUrl": "assets/Movies/Titanic.jpg"
          },
          {
            "movieName": "Shutter Island",
            "imageUrl": "assets/Movies/K7.jpg"
          },
          {
            "movieName": "Guardians of The Galaxy",
            "imageUrl": "assets/Movies/K8.jpg"
          },
          {
            "movieName": "Empire Strikes Back",
            "imageUrl": "assets/Movies/K9.jpg"
          },
          {
            "movieName": "Dora & The Lost City Of Gold",
            "imageUrl": "assets/Movies/K10.jpg"
          },
          {
            "movieName": "Harry Potter",
            "imageUrl": "assets/Movies/K11.jpg"
          },
          {
            "movieName": "Jaws",
            "imageUrl": "assets/Movies/K12.jpg"
          },
          {
            "movieName": "Avengers Infinity War",
            "imageUrl": "assets/Movies/K13.jpg"
          },
          {
            "movieName": "John Wick",
            "imageUrl": "assets/Movies/K14.jpg"
          },
          {
            "movieName": "Beauty & The Beast",
            "imageUrl": "assets/Movies/k15.jpg"
          },
          {
            "movieName": "Replicas",
            "imageUrl": "assets/Movies/K1.jpg"
          },
          {
            "movieName": "Joker",
            "imageUrl": "assets/Movies/K2.jpg"
          },
          {
            "movieName": "Casino",
            "imageUrl": "assets/Movies/K3.jpg"
          },
          {
            "movieName": "SuperBad",
            "imageUrl": "assets/Movies/K8.jpg"
          }
        ]
      },
      {
        "sectionName": "Asian Dramas",
        "sectionDetail": [
          {
            "movieName": "The Rocky Horror Picture Show",
            "imageUrl": "assets/Movies/AD1.jpg"
          },
          {
            "movieName": "The Quiet Girl",
            "imageUrl": "assets/Movies/AD2.jpg"
          },
          {
            "movieName": "The Picture of Dorian Gray",
            "imageUrl": "assets/Movies/AD3.jpg"
          },
          {
            "movieName": "Jurassic Park",
            "imageUrl": "assets/Movies/AD4.jpg"
          },
          {
            "movieName": "House Of Gucci",
            "imageUrl": "assets/Movies/AD5.jpg"
          },
          {
            "movieName": "The Wolf of Wall Street",
            "imageUrl": "assets/Movies/AD6.jpg"
          },
          {
            "movieName": "Titanic",
            "imageUrl": "assets/Movies/AD19.jpg"
          },
          {
            "movieName": "Shutter Island",
            "imageUrl": "assets/Movies/AD7.jpg"
          },
          {
            "movieName": "Guardians of The Galaxy",
            "imageUrl": "assets/Movies/AD8.jpg"
          },
          {
            "movieName": "Empire Strikes Back",
            "imageUrl": "assets/Movies/AD9.jpg"
          },
          {
            "movieName": "Dora & The Lost City Of Gold",
            "imageUrl": "assets/Movies/AD10.jpg"
          },
          {
            "movieName": "Harry Potter",
            "imageUrl": "assets/Movies/AD11.jpg"
          },
          {
            "movieName": "Jaws",
            "imageUrl": "assets/Movies/AD12.jpg"
          },
          {
            "movieName": "Avengers Infinity War",
            "imageUrl": "assets/Movies/AD13.jpg"
          },
          {
            "movieName": "John Wick",
            "imageUrl": "assets/Movies/AD14.jpg"
          },
          {
            "movieName": "Beauty & The Beast",
            "imageUrl": "assets/Movies/AD15.jpg"
          },
          {
            "movieName": "Replicas",
            "imageUrl": "assets/Movies/AD16.jpg"
          },
          {
            "movieName": "Joker",
            "imageUrl": "assets/Movies/AD17.jpg"
          },
          {
            "movieName": "Casino",
            "imageUrl": "assets/Movies/AD18.jpg"
          },
          {
            "movieName": "SuperBad",
            "imageUrl": "assets/Movies/AD20.jpg"
          }
        ]
      }
    ]
  }